export default {   
    //  印尼语1
    public:{
        subject: 'Subjek',
        author: 'pengarang',
        select: 'Saring',
        item:'Jumlah item',
        keywords: 'Kata-kata kunci',
        load:'Pemuatan...',
        nodata:'Tidak ada data',
        close:'Menutup',
        all:'Semua',
        cancel:'Membatalkan',
        traditionalChinese:'Cina tradisional',
        thai:'Thai',
        indonesian:'Indonesia',
        malay:'Melayu',
        filipino:'Filipina',

        successful:'Registrasi berhasil',
        loginTips: 'Silakan masuk ke akun pribadi Anda',
        loginSuccess: 'Login berhasil',
        library:'ChatAnswer Sistem referensi AI perpustakaan',
        fellows:'ChatFellows Sistem penemuan / kutipan rekan intra-institusi',
        research:'ChatResearch Platform penyelidikan akademis yang efisien dan personal',
        language:'ChatLanguage Terjemahan cerdas AI multibahasa dan sistem pengoreksian tata bahasa',
        document:'ChatDocuments Alat penguraian dokumen yang mendalam',
        data:'ChatData Alat penguraian tabel data mendalam',
        other:'Lain',
        feedSuccess:'Umpan balik masalah berhasil!',
        codeTips:'Kode verifikasi telah terkirim, harap periksa dengan teliti',
        overtime:'Waktu permintaan habis'	
    },
    header:{
        feedback:'Masukan',
        quit:'Berhenti',        
        personal:'Masuk ke akun pribadi',
      
        language:'Bahasa keluaran',
        username:'Nama belakang',
        password:'Kata sandi',
        log:'Gabung',
        noRegistered:'Tidak ada akun yang terdaftar',
        register:'Daftar',
        personalAccount:'Daftarkan akun pribadi',
        accountUsername:'Username akun',
        tips:'Silakan masukkan akun/nama pengguna',
        tipsPassword:'Silakan masukkan kata sandi',
        confirmPassword:'Kumpirmahin ang Password',
        tipsConfirmPassword:'Harap konfirmasi kata sandi lagi',
        email:'Surat',
        tipsEmail:'Silakan masukkan email Anda',
        phone:'Nomor telepon',
        tipsPhone:'Silakan masukkan nomor telepon',
        verificationCode:'Kode verifikasi ponsel',
        tipsVerificationCode:'Silakan masukkan kode verifikasi ponsel',
        sendVerificationCode:'Memperoleh',
        back:'Kembali',
        module:'Modul fungsional',
        selectTip:'Silakan pilih modul fungsional yang bermasalah',
        question:'Deskripsi Masalah',
        screenshot:'Tangkapan layar masalah',
        upload:'Klik untuk mengunggah',
        type:'Hanya mendukung pengunggahan format .jpg/.png',
        passwordTip:'Silakan masukkan kata sandi 6-24 digit',
        enterAgain:'Silakan masukkan kata sandi lagi',
        inconsistent:'Kata sandi yang dimasukkan dua kali tidak konsisten',
        enterCode:'silakan masukkan kode verifikasi',
        emailTip:'Silakan masukkan alamat email yang benar',
        enterEmail:'Silakan masukkan alamat email',
        otherQuestion:'Apakah Anda memiliki pertanyaan lain yang serupa dengan masalah ini',
        example:'Misalnya',
        bibliography:'bibliografi perpustakaan',
        logOut:'Apakah Anda yakin ingin keluar dari akun Anda',
        sure:'Tentu',
        switching:'Berhasil beralih ke berbagai bahasa',
        again:'Kirim ulang setelah',
        again2:'detik',
        hello:'Salam'
    },
    login:{
        log:'Gabung',
        institutionalLogin:'Login institusi',
        personalLogin:'Login pribadi',
        accountRegistration:'Daftar akun',
        retrievePassword:'Ambil kata sandi',
        usernameTip:'Silakan masukkan nama pengguna organisasi Anda',
        personal:'Silakan masukkan nama pengguna pribadi Anda',
        forget:'Lupa kata sandinya?',
        ipLog:'Masuk IP',
        institutional:'Mekanisme',
        institutionalTip:'Silakan pilih institusi1',
        country:'Bangsa',
        countryTip:'Silakan pilih negara',
        invitationCode:'Kode undangan',
        codeTip: 'Silakan masukkan kode undangan',
        newPass:'Kata sandi baru',
        newPassTip:'Silakan masukkan kata sandi baru',
        elmaiCode:'Kode verifikasi email',
        elmaiTip:'Silakan masukkan kode verifikasi email',
        resetting:'Mengatur ulang kata sandi',
        logTip: 'Nama pengguna organisasi tidak boleh kosong',

        truePhone:'Silahkan masukkan nomor telepon yang benar',
        successful:'Pendaftaran akun berhasil, silakan login kembali!',
        passwordReset:'Penyetelan ulang kata sandi berhasil, silakan masuk lagi!',

        noteTitle:'Catatan untuk mendapatkan kode verifikasi:',
        noteOne:'1. Untuk memastikan kode verifikasi dapat dikirimkan tepat waktu dan akurat, sebaiknya gunakan penyedia layanan email berikut: Gmail, Outkook, Yahoo;',
        noteTwo:'2. Karena mekanisme penyaringan dari masing-masing penyedia layanan email, terkadang email kode verifikasi mungkin salah dinilai sebagai spam atau email tidak valid. Silakan periksa apakah email kode verifikasi ada di recycle bin spam.',
    },
    chatlibrary: {
        questionOne:'Menanyakan tentang masalah peminjaman perpustakaan',
        questionTwo: 'Menanyakan tentang masalah yang terkait dengan database yang dibeli',
        questionThree: 'Menanyakan tentang masalah yang berkaitan dengan sumber daya digital perpustakaan',
        quickAccess:'Akses cepat',
        disclaimer: 'Penafian',
        further:'pertanyaan lebih lanjut',
        goon:'Melanjutkan',
        statementOne: '1. Konten balasan ChatAnswer didasarkan pada tanggapan terhadap pertanyaan umum dan informasi publik pada sumber terkait.Konten sebenarnya tunduk pada informasi resmi yang diterbitkan oleh perpustakaan dan konten resmi dari sumber sumber.',
        statementTwo: '2. Hasil terjemahan dari fungsi terjemahan hanya untuk referensi. Platform tidak bertanggung jawab atas kerugian apa pun yang disebabkan oleh keakuratan atau keandalan informasi terjemahan di situs web; konten dalam teks terjemahan hanya mewakili pandangan dari penulis asli dan tidak mewakili pandangan dan pendapat platform. Ini tidak ada hubungannya dengan posisi pengembang platform.',
        statementThree: '3. Fungsi pengoreksian tata bahasa hanya mengoreksi berdasarkan masalah linguistik dan tata bahasa dari konten dan tidak dapat mencapai tingkat pemolesan bahasa buatan. Platform tidak bertanggung jawab atas segala kerugian yang disebabkan oleh ketergantungan yang berlebihan pada hasil pengoreksian tata bahasa.',
        statementFour: '4. Jika pembaca mengirimkan artikel ke publikasi berdasarkan hasil rekomendasi kesamaan, mereka harus mengkonfirmasi ulang informasi masalah dan menghubungi departemen editorial sebelum mengirimkannya.Kami tidak bertanggung jawab atas kerugian yang disebabkan oleh ketergantungan buta pada informasi yang disediakan oleh situs web.',
        statementFive: '5. Pendapat yang diungkapkan dalam pertanyaan, persyaratan pencarian, teks, dan file yang diunggah oleh pembaca tidak mewakili pandangan dan opini platform, dan tidak ada hubungannya dengan posisi pengembang platform.',
        // 手机端
        statementOneMobile: '1. Konten balasan ChatAnswer didasarkan pada tanggapan terhadap pertanyaan umum dan informasi publik pada sumber terkait.Konten sebenarnya bergantung pada informasi resmi perpustakaan dan konten sumber sumber resmi.',
        statementTwoMobile: '2. Hasil terjemahan dari fungsi terjemahan hanya untuk referensi. Platform tidak bertanggung jawab atas kerugian apa pun yang disebabkan oleh keakuratan atau keandalan informasi terjemahan di situs web; konten dalam teks terjemahan hanya mewakili pandangan dari penulis asli dan tidak mewakili pandangan dan pendapat platform. Ini tidak ada hubungannya dengan posisi pengembang platform.',
        statementThreeMobile: '3. Fungsi pengoreksian tata bahasa hanya mengoreksi berdasarkan masalah tata bahasa linguistik dari konten dan tidak dapat mencapai tingkat pemolesan bahasa buatan. Platform tidak bertanggung jawab atas segala kerugian yang disebabkan oleh ketergantungan yang berlebihan pada hasil pengoreksian tata bahasa.',
        statementFourMobile: '4. Jika pembaca mengirimkan artikel ke publikasi berdasarkan hasil rekomendasi kesamaan, mereka perlu mengkonfirmasi ulang informasi jurnal dan menghubungi departemen editorial sebelum mengirimkannya.Kami tidak bertanggung jawab atas kerugian yang disebabkan oleh ketergantungan buta pada informasi yang disediakan oleh situs web.',
        statementFiveMobile: '5. Pendapat yang diungkapkan dalam pertanyaan, persyaratan pencarian, teks, dan file yang diunggah oleh pembaca tidak mewakili pandangan dan opini platform, dan tidak ada hubungannya dengan posisi pengembang platform.',
        // 进入弹窗文本
        hellow: 'Halo: Selamat datang konsultasi Anda, saya',
        introduceOne: 'Asisten AI cerdas ChatAnswer dengan senang hati melayani Anda.',
        introduceTwo: '1. Jam buka perpustakaan',
        introduceThree: '2. Bagaimana cara menemukan sumber daya digital?',
        introduceFour: '3. Apa yang harus saya lakukan jika buku yang dipinjam hilang secara tidak sengaja?',
        introduceFive: '4. Memperkenalkan database yang berhubungan dengan medis',
        introduceSix: '5. Bagaimana cara mengakses sumber daya digital perpustakaan di luar kampus?',
        introduceSeven: 'Anda dapat mengajukan pertanyaan kepada saya tentang perpustakaan, misalnya Anda dapat bertanya kepada saya "Bagaimana cara memeriksa dan menemukan buku yang Anda butuhkan?" "Jam buka perpustakaan" "Aturan peminjaman buku", dll. Saya akan mencoba yang terbaik untuk menjawab Anda; dan tentang Kami juga dapat menjawab pertanyaan seputar buku, database dan layanan perpustakaan lainnya, seperti:',
        questions: 'Pertanyaan lebih lanjut',
        Continue:'Melanjutkan',
        recording:'Rekaman klik mouse',
        stopRecording:'Klik mouse untuk berhenti merekam',
        microphone:'Izinkan halaman ini menggunakan mikrofon terlebih dahulu',
        browserTips:'Browser Anda tidak mendukung pengenalan suara',
        browserTips2:'Browser Anda tidak mendukung pengenalan volume suara',
        progress:'Pengenalan ucapan sedang berlangsung...',
        failed:'Pengenalan suara gagal',
    },
    chatresearch: {
        theme: 'ChatResearch | Penemuan mendalam berbasis semantik',
        themeMobile: 'Penemuan mendalam berbasis semantik',
        switchSemantics: 'Ganti pencarian semantik',
        switchTraditional: 'Beralih ke pencarian tradisional',
        title: 'Judul',
        results:'Hasil unggulan',
        source:'Sumber',
        year: 'Tahun penerbitan',
        abstract: 'Ringkasan',
        tips: 'Silakan masukkan konten pencarian...',
        select: 'Tolong pilih',
        issn: 'ISSN',
        introduce_tit: 'Pengenalan Platform',
        introduceOne: 'ChatResearch akan menggunakan kecerdasan buatan dan teknologi canggih untuk menyediakan platform penelitian akademis yang lebih komprehensif, personal, dan efisien kepada pembaca. Fitur inti meliputi:',
        introduceTwo: 'Sistem pencarian semantik lintas bahasa: Melalui pemahaman mendalam tentang maksud dan minat pencarian pembaca, serta grafik pengetahuan lintas bahasa, sistem pencarian semantik lintas bahasa pada platform ChatResearch akan memberikan hasil pencarian yang lebih komprehensif dan akurat.',
        introduceThree: 'Manajemen dokumen batch: Alat manajemen dokumen batch dapat membantu peneliti, akademisi, dan kelompok lain dengan cepat memproses konten dokumen dalam jumlah besar. Mereka dapat menerapkan klasifikasi, anotasi, pencarian, pemfilteran, anotasi, pengunduhan, dan berbagai fungsi otomatis, sehingga sangat meningkatkan manajemen dokumen dan efisiensi penelitian ilmiah.',
        search:'Pencarian logis tradisional',
        searchAll:'Cari semua',
        searchTip:'Anda dapat menggunakan teks lengkap abstrak, paragraf dari literatur, atau teks deskripsi rinci sebagai konten pencarian. Sistem dapat menerapkan pengambilan semantik berdasarkan perbandingan kesamaan semantik. Semakin panjang konten input, semakin akurat efek pencocokannya.',
        clear:'Bersihkan pencarian',
        link:'Tautan artikel',
        Similar:'Dokumen serupa',
        followingresults:'Cari hasil berikut',
        chinese:'Cina',
        english:'Bahasa inggris',
        total:'Kembalikan jumlah total hasil',
        introduceFour:'Sistem penemuan subjek berdasarkan analisis semantik dan pencocokan kesamaan, yang dapat mencapai pengambilan yang efisien dan cerdas dalam berbagai bahasa.',
        volume:'Silakan pilih volume pencarian',
        
        inputTips:'Isi kotak masukan saat ini tidak boleh kosong!'
    },
    chatlanguage: {
        enter: 'Memasuki',
        errorChecking: 'Temukan kesalahan tata bahasa dalam bahasa Inggris',
        CToE: 'Bahasa Cina ke Bahasa Inggris',
        EToC: 'Bahasa Inggris ke Bahasa Mandarin',
        docTran: 'Terjemahan dokumen terjemahan',
        functionIntroduction: 'Fitur',
        introduceOne: 'Anda dapat menggunakan fungsi "Temukan Kesalahan Tata Bahasa Inggris" untuk melakukan pengoreksian tata bahasa yang cerdas pada konten teks bahasa Inggris. Setelah memasukkan konten, sistem dapat dengan cerdas mengidentifikasi dan memperbaiki masalah tata bahasa dalam makalah. Mendukung koreksi struktur kalimat, tense, penggunaan subjek dan predikat, tanda baca dan jenis masalah lainnya, membantu meningkatkan kualitas artikel dan meningkatkan keterbacaan dan keakuratan ekspresi.',
        introduceTwo: 'Anda dapat menggunakan fungsi "Pemolesan Akademik Bahasa Inggris" untuk memoles dan mengoptimalkan teks bahasa Inggris. Sistem akan memodifikasi teks dari sudut pandang kelancaran dan keanggunan agar lebih halus dan ringkas. Tambahkan pesona profesional pada teks dan buat ide tema tampak lebih jelas.',
        tips: 'Silakan masukkan konten kueri',
        basic:'Fungsi dasar',
        polish:'Penulisan Ulang Akademik Bahasa Inggris',
        inputTips:'Silakan masukkan konten teks yang memerlukan pengoreksian atau pemolesan',

        againRequest:'Permintaan gagal! Coba lagi!',
    },
    chatfellows:{
        introduceOne:'Platform Penemuan Cerdas Pencapaian —— Berdiri di atas bahu para pendahulu',
        introduceTwo:'Pengenalan platform',
        introduceThree_one:'Teman Obrolan',
        introduceThree_two:'Hasil platform penemuan cerdas adalah a',
        introduceThree:'Alat pencarian akademis cerdas yang dibuat oleh peneliti ilmiah. Berdasarkan integrasi komprehensif hasil kelembagaan, penghitungan kesamaan semantik, teknologi vektorisasi, persepsi bahasa alami, dan teknologi lainnya diterapkan untuk mencapai pemanfaatan hasil yang mendalam dan multi-dimensi, mencapai pencocokan hasil yang cerdas dan akurat, pemilahan kesamaan, dan mewujudkan lintas - Language Retrieval and Matching, efektif membantu peneliti ilmiah dalam melaksanakan penelitian ilmiah dan karya tulis seperti penelitian literatur akademis, pengambilan referensi, dan seleksi jurnal.',
        introduceFour:'Platform penemuan cerdas hasil telah sepenuhnya mengintegrasikan dan mengumpulkan hasil penelitian utama sekolah kami. Melalui penerapan teknologi AI cerdas yang mendalam, hasilnya dapat diterapkan secara efektif dan membantu pengembangan karya penelitian ilmiah secara efektif. Berkomitmen untuk membantu pengguna dengan cepat dan akurat menemukan makalah berkualitas tinggi di bidang terkait, meningkatkan efisiensi penelitian, dan membantu mencapai hasil akademis. Berdirilah di pundak para raksasa dan terus dorong kemajuan penelitian akademis yang berkelanjutan.',
        introduceFive:'Fungsi inti',
        introduceSix:'Pengambilan pencocokan cerdas: wujudkan penemuan makalah serupa yang efisien dalam hasil sumber evaluasi penting sekolah kami.',
        introduceSeven:'Pengambilan kembali lintas bahasa: Melalui penerapan teknologi vektorisasi, pengambilan dan pencocokan diwujudkan tanpa batasan bahasa.',
        introduceTen:'Penyortiran optimasi kesamaan: Hasil pencocokan optimal disajikan berdasarkan kesamaan makalah, sehingga memudahkan pembaca ilmiah untuk dengan cepat menemukan hasil penelitian yang paling relevan.',
        introduceEight:'Tampilan informasi terperinci: Platform ini menyediakan informasi literatur terperinci dari hasil pencarian dan ringkasan terjemahan hasil bahasa asing, memungkinkan pengguna dengan cepat memahami inti dari hasil.',
        introduceNine:'Pembaruan yang sangat tepat waktu: Platform ini secara teratur menyinkronkan database sumber evaluasi penting untuk memastikan bahwa pembaca dapat memahami hasil terbaru.',
        knowBtn:'Jadi begitu',
        enter:'Memasuki',
        title:'Platform Penemuan Cerdas Pencapaian —— Berdiri di atas bahu para pendahulu',
        tips:'Silakan masukkan abstrak atau topik artikel yang ingin Anda cari (judul, kata kunci, dll.), dan sistem akan membantu Anda menemukan makalah serupa dari sekolah kami di sumber evaluasi utama (tidak diperlukan terjemahan dan konversi khusus untuk bahasa Mandarin !)',
        submit:'Kirim',
        relatedLiterature:'Literatur terkait',
        year:'Bertahun-tahun',

        enSummary:'Ringkasan bahasa Inggris',
        cnSummary:'Ringkasan bahasa Mandarin',
    },
    chatdocument:{
        title:'Alat penguraian dokumen yang mendalam',
        introduce:'Mewujudkan ekstraksi konten data dokumen dan analisis teks lengkap dari topik dan cakupan tertentu, sehingga membantu dalam penelitian mendalam.',
        start:'Mulailah mengalami',
        ask:'Ajukan pertanyaan tentang dokumentasi dan dapatkan jawaban yang Anda butuhkan',
        createSession:'Buat percakapan dan ajukan pertanyaan tentang beberapa dokumen secara bersamaan',
        quoting:'Mengutip bagian-bagian dan analisis mendalam terhadap isi literatur',
        analyze:'Analisis grafik dan ekstrak data untuk analisis komprehensif',
        tool:'Asisten penguraian dokumen yang sangat efisien',
        list:'Daftar literatur',
        conversation:'Daftar percakapan',
        createAsk:'Buat sesi',
        upload:'Unggah Berkas',
        drag:'Seret file atau klik untuk mengunggah',
        introduceOne:'Ajukan pertanyaan tentang konten dokumen dan dapatkan jawaban langsung melalui obrolan.',
        introduceTwo:'ChatDocuments adalah asisten penguraian file yang dapat dengan cepat mengekstrak, menemukan, dan meringkas informasi dari dokumen.',
        quick:'Akses cepat',
        enter:'Silakan masukkan konten...',
        askQuestion:'Berikan pertanyaan',
        example:'Contoh',
        busy:'Layanan sedang sibuk, silakan coba lagi',
        stop:'Berhenti menjawab',
        onlyAsk:'Ajukan pertanyaan hanya tentang artikel saat ini',
        chapter:'Bab',
        create:'Membuat',
        editsession:'Sesi edit',
        sessionname:'Nama sesi',
        currentlyselected:'Saat ini dipilih',
        fileselection:'Pemilihan berkas',
        revise:'Merevisi',
        docLanguage:'Bahasa dokumen',
        zhDoc:'Dokumentasi Tiongkok',
        enDoc:'Dokumen bahasa Inggris',
        support:'*Hanya mendukung pengunggahan file pdf',
        nowUpload:'Sedang mengunggah, harap tunggu...',
        question:'Bahasa dokumen tidak cocok dan tidak dapat dipilih',
        editTitle:'Klik dua kali untuk mengedit nama file',

        uploadSuccess:'Unggahan berhasil',
        sideBar:'Kecilkan bilah sisi',
        noData:'Tidak ada tabel parsable yang ditemukan dalam dokumen',
        delConfirm:'Apakah Anda yakin ingin menghapus file ini?',
        unable:'Tidak dapat mengurai excel',
        delSuccess:'Berhasil dihapus',
        selFile:'Silakan pilih file',
        inputName:'Silakan masukkan nama sesi',
        createSuccess:'Berhasil dibuat',
        fileTips:'File sedang dikonversi, silakan coba lagi nanti',
        failFile:'Konversi file gagal, harap unggah lagi',
        defaultQuestion1:'Bidang apa saja yang disertakan dalam tabel dan data apa saja yang dijelaskan?',
        defaultQuestion2:'Silakan hitung rata-rata setiap kolom data?',
        defaultQuestion3:'Tolong hitung median setiap kolom data?',
        defaultQuestion4:'Berapa nilai yang paling sering muncul di setiap kolom data?',
        defaultQuestion5:'Informasi apa yang dapat kita peroleh dari data dalam tabel, dan kesimpulan apa yang dapat kita tarik dari analisis tersebut?',
    },
    chatdata:{
        title:'Alat analisis cerdas data mendalam',
        introduce:'Temukan wawasan dari data Anda melalui penguraian cerdas dan analisis mendalam. Gunakan fungsi analisis visual untuk mendapatkan tampilan yang jelas dalam bentuk grafik.',
        start:'Mulailah mengalami',
        ask:'Ajukan pertanyaan tentang dokumentasi dan dapatkan jawaban yang Anda butuhkan',
        create:'Buat percakapan dan ajukan pertanyaan tentang beberapa dokumen secara bersamaan',
        quoting:'Mengutip bagian-bagian dan analisis mendalam terhadap isi literatur',
        analyze:'Analisis grafik dan ekstrak data untuk analisis komprehensif',
        tool:'Asisten penguraian dokumen yang sangat efisien',
        list:'Daftar literatur',
        conversation:'Daftar percakapan',
        createAsk:'Buat sesi',
        upload:'Unggah Berkas',
        drag:'Seret file atau klik untuk mengunggah',
        introduceOne:'ChatData memungkinkan pertanyaan percakapan dengan tabel melalui analisis tabel dan kumpulan data yang cerdas. Dan melalui analisis mendalam, grafik visual dapat dibuat secara otomatis untuk memperjelas data dalam sekejap!',
        quick:'Akses cepat',
        enter:'Silakan masukkan konten...',
        hint:'petunjuk',
        hintOne:'Modul ini sedang dalam pemeliharaan dan untuk sementara tidak tersedia. Terima kasih atas pengertian dan kesabaran Anda.',
        Isee:'Jadi begitu',
    },
    chatopen:{
        title:'Mesin penemuan pengetahuan terbuka Anda',
        switch:'Beralih ke pencarian tradisional',
        introduce:'Dapatkan dan temukan hasil penelitian ilmiah terkini di bidang fisika, matematika, ilmu komputer, kecerdasan buatan, statistik, dll., dan pahami tren perkembangan',
        features:'Fitur',
        featureOne:'Gunakan kecerdasan buatan dan teknologi canggih untuk memberikan pengalaman penemuan pengetahuan yang lebih efisien, kuat, dan akurat kepada peneliti ilmiah. ChatOpen menerapkan teknologi pengambilan semantik untuk mencapai pemahaman mendalam tentang maksud pencarian, minat, dan pemetaan lintas bahasa pembaca.',
        featureTwo:'Integrasikan metadata pengetahuan terbuka yang besar untuk memberikan pembaca ilmiah berbagai jenis hasil akademik sumber terbuka termasuk dokumen akses terbuka, pracetak, dll. Dikombinasikan dengan penemuan semantik, kami berharap sumber daya ini dapat membantu Anda mempromosikan inovasi penelitian akademis dan menghubungkan Anda dengan masa depan yang terbuka.',
        translate:'Menerjemahkan',
        clear:'Hapus penyaring' ,
    },
    message:{
        authority: "Tidak ada izin",
        upload: "Hanya format .jpg/.png yang didukung!",
        apply: "Aplikasi uji coba telah dikirimkan, harap bersabar!",
        delete: "Apakah Anda yakin ingin menghapus file ini?",
        size: "Ukuran file tidak boleh melebihi 20MB",
        wait: "Sedang diproses, harap tunggu"
    }
}
